(function(){
  if(window.__OW_APP_DELAY_SAFE__) return;
  window.__OW_APP_DELAY_SAFE__ = true;

  var pageType = window.__OW_PAGE_TYPE__ || '';
  var queue = [];
  var released = false;

  var nativeAppend = Element.prototype.appendChild;
  var nativeInsert = Element.prototype.insertBefore;

  /*
    Keep theme, Shopify, product, cart, checkout, pixels, shipping, subscription,
    Amazon MCF, AutoDS/DSers normal.
  */
  var keepEarly = /cdn\.shopify\.com|shopifycdn|constants\.js|pubsub\.js|global\.js|swiper|custom\.js|product-variant|product-form|cart|checkout|shopifycloud\/web-pixels-manager|trekkie|monorail-edge\.shopifysvc|googletagmanager|google-analytics|analytics\.google|googleadservices|doubleclick|connect\.facebook|facebook\.com\/tr|fbevents|subzero|sendle|pirate|cheaparr|amazon|mcf|buywithprime|autods|dsers|aliexpress|flow|searchanddiscovery/i;

  /*
    Delay non-critical apps.
  */
  var delayApps = /clarity|tidio|crazyrocket|spin|wheel|smartseo|avada|reputon|judge\.me|judgeme|product.?recommendation.?quiz|quiz|bundles|transcy|messaging|buddy|make\.com|collective/i;

  function nodeUrl(node){
    if(!node || !node.tagName) return '';

    if(node.tagName === 'SCRIPT'){
      return node.src || node.getAttribute('src') || '';
    }

    if(node.tagName === 'LINK'){
      return node.href || node.getAttribute('href') || '';
    }

    return '';
  }

  function isDelayableLink(node){
    if(!node || node.tagName !== 'LINK') return false;

    var rel = (node.rel || node.getAttribute('rel') || '').toLowerCase();

    return (
      rel.indexOf('stylesheet') !== -1 ||
      rel.indexOf('preload') !== -1 ||
      rel.indexOf('font') !== -1
    );
  }

  function shouldDelay(node){
    var tag = node && node.tagName;
    var src = nodeUrl(node);

    if(released) return false;
    if(!src) return false;
    if(node.dataset && node.dataset.noDelay === 'true') return false;

    if(tag !== 'SCRIPT' && tag !== 'LINK') return false;
    if(tag === 'LINK' && !isDelayableLink(node)) return false;

    if(keepEarly.test(src)) return false;

    if(delayApps.test(src)) return true;

    /*
      Delay common third-party app domains only.
      Do not delay unknown theme scripts.
    */
    if(/clarity\.ms|tidio|judge\.me|judgeme|reputon|avada|transcy|crazyrocket|shopify:\/\/apps/i.test(src)){
      return true;
    }

    return false;
  }

  function hold(parent,node,before,mode){
    if(!shouldDelay(node)) return false;

    if(node.dataset){
      node.dataset.owDelayed = 'true';
    }

    queue.push([parent,node,before,mode]);
    return true;
  }

  Element.prototype.appendChild = function(node){
    return hold(this,node,null,0) ? node : nativeAppend.call(this,node);
  };

  Element.prototype.insertBefore = function(node,before){
    return hold(this,node,before,1) ? node : nativeInsert.call(this,node,before);
  };

  function idle(callback){
    if('requestIdleCallback' in window){
      requestIdleCallback(callback,{timeout:3000});
    } else {
      setTimeout(callback,1500);
    }
  }

  function release(){
    if(released) return;
    released = true;

    Element.prototype.appendChild = nativeAppend;
    Element.prototype.insertBefore = nativeInsert;

    var fallback = document.head || document.body || document.documentElement;

    queue.splice(0).forEach(function(item){
      var parent = document.documentElement.contains(item[0]) ? item[0] : fallback;

      if(item[1].dataset){
        item[1].dataset.owReleased = 'true';
      }

      try{
        if(item[3] && item[2] && item[2].parentNode === parent){
          nativeInsert.call(parent,item[1],item[2]);
        } else {
          nativeAppend.call(parent,item[1]);
        }
      } catch(e){
        nativeAppend.call(fallback,item[1]);
      }
    });

    document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
    document.dispatchEvent(new CustomEvent('StartKernelLoading'));
    window.dispatchEvent(new Event('OwSpeedLoaded'));
  }

  window.owLoadDelayedScripts = release;
  window.loadDelayedShopifyScripts = release;

  ['scroll','touchstart','keydown','click'].forEach(function(eventName){
    window.addEventListener(eventName,function(){
      setTimeout(function(){
        idle(release);
      },700);
    },{once:true,passive:true});
  });

  window.addEventListener('load',function(){
    setTimeout(function(){
      idle(release);
    }, pageType === 'product' ? 6500 : 4500);
  },{once:true});

  setTimeout(function(){
    idle(release);
  }, pageType === 'product' ? 11000 : 8500);
})();